import React from 'react'
import GitHubIcon from '@material-ui/icons/GitHub';
import './projectml.css'
import AOS from 'aos';
import 'aos/dist/aos.css';

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

AOS.init();

// You can also pass an optional settings object
// below listed default settings
AOS.init({
  // Global settings:
  disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
  startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
  initClassName: 'aos-init', // class applied after initialization
  animatedClassName: 'aos-animate', // class applied on animation
  useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
  disableMutationObserver: false, // disables automatic mutations' detections (advanced)
  debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
  throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
  

  // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
  offset: 120, // offset (in px) from the original trigger point
  delay: 200, // values from 0 to 3000, with step 50ms
  duration: 750, // values from 0 to 3000, with step 50ms
  easing: 'ease', // default easing for AOS animations
  once: false, // whether animation should happen only once - while scrolling down
  mirror: false, // whether elements should animate out while scrolling past them
  anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation

});


function ProjectML({projectNo,projectName,projectLink ,projectSrc,projectDesc}) {
    return (
        <div className = 'project-ml' data-aos = {projectNo === '1'?'fade-down-right':'zoom-in'} data-aos-delay="400" data-aos-duration="1500">
            <div className = 'project-ml-img'>
                <LazyLoadImage className = 'project-ml-img-lazy' effect = "blur" src = {projectSrc} alt = 'projectML'/>
            </div>
            <div className = 'project-ml-desc'>
                <h1>{projectName}</h1>
                <div className = 'project-ml-desc-p'><p>{projectDesc}</p></div>
                <div className = 'project-ml-lang'>
                    <button>HTML</button>
                    <button>CSS</button>
                    <button>JavaScript</button>
                    <button>Python</button>
                </div>
                <a href = {projectLink} target = '_blank' rel="noopener noreferrer"  className = "project-ml-link"><GitHubIcon fontSize = 'large'/></a>
            </div>
        </div>
    )
}

export default ProjectML
